var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{staticStyle:{"height":"25vh","margin-bottom":"4vh"},attrs:{"src":require("@/assets/data-screen/chart6.png"),"alt":""}})])
}]

export { render, staticRenderFns }